import type { NavData } from '@assessments/shared'
import { resolveActiveNavEntry } from '@/lib/navActive'
import { NavBarItem } from './NavBarItem.js'

interface Props {
  nav: NavData | null
}

export function NavBar({ nav }: Props) {
  if (!nav) return null

  const active = resolveActiveNavEntry(nav.items)

  return (
    <nav className="hidden items-center lg:flex min-[1320px]:ml-4 min-[1320px]:space-x-1">
      {nav.items.map((item, index) => (
        <NavBarItem
          key={item.active_route_pattern}
          item={item}
          isActive={active?.itemIndex === index && active.childIndex === null}
          activeChildIndex={active?.itemIndex === index ? active.childIndex : null}
        />
      ))}
    </nav>
  )
}
